import React, { Component } from 'react';
import 'react-datetime/css/react-datetime.css';
import moment from 'moment';

import api from '../../api/api';
import { getTablaFacturacionPorFiltro } from '../../api/calls';

import ParadigmaTable from "../../components/ParadigmaTable/ParadigmaTable"
import ParadigmaDatePicker from "../../components/ParadigmaDatePicker/ParadigmaDatePicker"
import DateFilter from "../../components/ParadigmaTable/DateFilter";
import SelectSimple from "../../components/SelectSimple/SelectSimple";
import ModalCotizacionDolar from './ModalCotizacionDolar';

import dateFunctions from '../functions/dateFunctions';
import './Facturacion.scss';


class Facturacion extends Component {
    FECHA_DE_COBRO_FILTER = 'fechaDeCobro';

    constructor() {
        super();
        const startDate = moment().subtract(1, 'months');
        const endDate = moment();

        const filter = this.createDateFilter(startDate, endDate, this.FECHA_DE_COBRO_FILTER);

        this.state = {
            tableData: [], // Filas de la pagina actual en la tabla, Lo necesita ModalCotizacionDolar.

            filter: filter,
            startDate: startDate,
            endDate: endDate,

            selectedRangoSegun: this.FECHA_DE_COBRO_FILTER,

            montoTotalPesos: 0,
            montoTotalDolarOficial: 0,
            montoTotalDolarMep: 0,
        };
    }

    createDateFilter(startDate, endDate, fechaSegun) {
        const fechaFilter = fechaSegun ? fechaSegun : this.FECHA_DE_COBRO_FILTER;
        let filter = [];

        const startMoment = moment(startDate);
        const endMoment = moment(endDate);

        if (startMoment.isValid() && endMoment.isValid()) {
            filter.push({
                'id': fechaFilter,
                'value': {
                    input: startMoment.format('YYYY-MM-DD'),
                    lookup: "date__gte"
                }
            });

            filter.push({
                'id': fechaFilter,
                'value': {
                    input: endMoment.format('YYYY-MM-DD'),
                    lookup: "date__lte"
                }
            });
        }

        return filter;
    }

    /**
    * Se recuperan todas las filas filtradas y tambien se usan solo las filas de la pagina actual.
    * Todas las filas --> Para saber el monto total filtrado a traves de todas las paginas.
    * Filas de pagina actual --> Para que ModalCotizacionDolar pueda recuperar datos de la fila seleccionada.
    */
    onDataChange = (data) => {
        let montoTotalPesos = 0;
        let montoTotalDolarOficial = 0;
        let montoTotalDolarMep = 0;

        getTablaFacturacionPorFiltro(this.state.filter).then((response) => {
            response.rows.forEach((row) => {
                montoTotalPesos += row.monto;
                montoTotalDolarOficial += row.monto_dolar_oficial;
                montoTotalDolarMep += row.monto_dolar_mep;
            }) 
            this.setState({
                tableData: data,

                montoTotalPesos: montoTotalPesos,
                montoTotalDolarOficial: montoTotalDolarOficial,
                montoTotalDolarMep: montoTotalDolarMep,
            })
        })
    }

    onFechaChange(startDate, endDate) {
        const filter = this.createDateFilter(startDate, endDate, this.state.selectedRangoSegun);

        this.setState({
            filter: filter,
            startDate: moment(startDate),
            endDate: moment(endDate)
        });
    }

    onFechaSegunChange = (fechaSegun) => {
        const { startDate, endDate } = this.state;

        const filter = this.createDateFilter(startDate, endDate, fechaSegun);

        this.setState({ 
            filter: filter,
            selectedRangoSegun: fechaSegun,
        });
    }

    render() {
        const {
            tableData,

            selectedRangoSegun,

            montoTotalPesos,
            montoTotalDolarOficial,
            montoTotalDolarMep,
        } = this.state;

        const columns = [
            {
                Header: "pk",
                id: "pk",
                accessor: d => d.pk,
                private: true,
                show: false,
            },
            {
                Header: "Nro. Presupuesto",
                id: "numero_presupuesto",
                accessor: d => d.numero_presupuesto ? d.numero_presupuesto.toUpperCase() : '-',
                show: true,
            },
            {
                Header: "Título",
                id: "titulo",
                accessor: data => data.titulo ? data.titulo : '-',
                show: true,
            },
            {
                width: 150,
                Header: "Empresa/Organización",
                id: "empr_org",
                accessor: data => data.empr_org ? data.empr_org : '-',
                show: true,
            },
            {
                Header: "Tipo de Transferencia",
                id: "tipo_transferencia",
                accessor: data => data.tipo_transferencia ? data.tipo_transferencia : '-',
                show: true,
            },
            {
                Header: "Subtipo de Transferencia",
                id: "subtipo_transferencia",
                accessor: data => data.subtipo_transferencia ? data.subtipo_transferencia : '-',
                show: true,
            },
            {
                Header: "Modo de Vinculación",
                id: "modo_vinculacion",
                accessor: data => data.modo_vinculacion ? data.modo_vinculacion : '-',
                show: true,
            },
            {
                Header: "LTP",
                id: "ltp_nombre",
                accessor: data => data.ltp_nombre ? data.ltp_nombre : '-',
                show: true,
            },
            {
                Header: "Grupo",
                id: "grupo",
                accessor: data => data.grupo ? data.grupo : '-',
                show: true,
            },
            {
                Header: "Estado del Plan de Trabajo",
                id: "estado_plan_trabajo",
                accessor: data => data.estado_plan_trabajo ? data.estado_plan_trabajo : '-',
                show: true,
            },
            {
                Header: "Etapas",
                id: "etapas",
                accessor: data => data.etapas ? data.etapas : '-',
                show: true,
            },
            {
                Header: "Fecha del Presupuesto",
                id: "fecha_presupuesto",
                accessor: d => d.fecha_presupuesto ? dateFunctions.parseDate(d.fecha_presupuesto) : '-',
                show: true,
            },
            {
                Header: "UVT",
                id: "uvt",
                accessor: data => data.uvt ? data.uvt : '-',
                show: true,
            },
            {
                Header: "Valor Final",
                id: "valor_final",
                accessor: data => data.valor_final ? data.valor_final : '-',
                show: true,
            },
            {
                Header: "Moneda",
                id: "moneda",
                accessor: data => data.moneda ? data.moneda : '-',
                show: true,
            },
            {
                Header: "LTE",
                id: "lte_nombre",
                accessor: data => data.lte_nombre ? data.lte_nombre : '-',
                show: true,
            },
            {
                Header: "Estado del Presupuesto",
                id: "estado_presupuesto",
                accessor: data => data.estado_presupuesto ? data.estado_presupuesto : '-',
                show: true,
            },
            {
                Header: "Número de Factura",
                id: "nroFactura",
                accessor: data => data.nroFactura ? data.nroFactura : '-',
                show: true,
            },
            {
                className: "text-center",
                Header: "Fecha Facturación",
                id: "fechaDeFacturacion",
                accessor: d => d.fechaDeFacturacion ? dateFunctions.parseDate(d.fechaDeFacturacion) : '-',
                show: true,
                Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />,
            },
            {
                className: "text-center",
                Header: "Fecha Cobro",
                id: this.FECHA_DE_COBRO_FILTER,
                accessor: d => d.fechaDeCobro ? dateFunctions.parseDate(d.fechaDeCobro) : '-',
                show: true,
                Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />,
            },
            {
                Header: "Monto ($)",
                id: "monto",
                className: "text-right",
                accessor: d => d.monto ? dateFunctions.formatCurrency(d.monto) : '-',
                show: true,
            },
            {
                Header: "Cotización oficial ($)",
                id: "cotizacion_dolar_oficial",
                className: "text-right",
                accessor: d => d.cotizacion_dolar_oficial ? dateFunctions.formatCurrency(d.cotizacion_dolar_oficial) : '-',
                show: true,
            },
            {
                Header: "Cotización MEP ($)",
                id: "cotizacion_dolar_mep",
                className: "text-right",
                accessor: d => d.cotizacion_dolar_mep ? dateFunctions.formatCurrency(d.cotizacion_dolar_mep) : '-',
                show: true,
            },
            {
                Header: "Monto Dólar Oficial (USD)",
                id: "monto_dolar_oficial",
                className: "text-right",
                accessor: d => d.monto_dolar_oficial ? dateFunctions.formatCurrency(d.monto_dolar_oficial) : '-',
                show: true,
            },
            {
                Header: "Monto Dólar MEP (USD)",
                id: "monto_dolar_mep",
                className: "text-right",
                accessor: d => d.monto_dolar_mep ? dateFunctions.formatCurrency(d.monto_dolar_mep) : '-',
                show: true,
            },
            {
                Header: "País",
                id: "impacta_pais",
                accessor: data => data.impacta_pais ? data.impacta_pais : '-',
                show: true,
            },
            {
                Header: "Provincia",
                id: "impacta_provincia",
                accessor: data => data.impacta_provincia ? data.impacta_provincia : '-',
                show: true,
            },
            {
                Header: "Ciudad",
                id: "impacta_ciudad",
                accessor: data => data.impacta_ciudad ? data.impacta_ciudad : '-',
                show: true,
            },
            {
                Header: "Polo Petroquímico",
                id: "polo_petroquimico",
                accessor: data => data.polo_petroquimico ? 'Si' : 'No',
                show: true,
            },
            {
                Header: "Clasificación de la Empresa",
                id: "empresa_clasificacion",
                accessor: data => data.empresa_clasificacion,
                show: true,
            },
        ]

        const opcionesRangoFechas = [
            { value: 'fechaDeFacturacion', label: 'Fecha De Facturación' },
            { value: this.FECHA_DE_COBRO_FILTER, label: 'Fecha De Cobro' }
        ]

        return (
            <ParadigmaTable
                title={"Facturación"}
                onDataChange={this.onDataChange}
                buttons={[
                    {
                        create: true,
                        permission: 'imputaciones_imputaciones_new',
                        component: (props) => <ModalCotizacionDolar
                            {...props}
                            tableData={tableData}
                        />,
                    },
                ]}
                columns={columns}
                defaultPageSize={18}
                apiUrl={api.imputaciones.imputaciones.facturas.list}
                exportUrl={api.imputaciones.imputaciones.facturas.export}
                outerSort={[{ "id": selectedRangoSegun, "desc": true }]}
                outerFilter={this.state.filter}
                customSearchElement={(
                    <div className="facturacion-search-container mimicTableHeader pb-1 pt-1">
                        <div className='div-rango-fechas box'>
                            <div className="d-flex align-items-center">
                                <div className='label'>Rango Según: </div>
                                <div className='select-rango-segun'>
                                    <SelectSimple
                                        name={"rangoSegun"}
                                        options={opcionesRangoFechas}
                                        value={opcionesRangoFechas.find(opcion => opcion.value === selectedRangoSegun)}
                                        onChange={selectedOption => this.onFechaSegunChange(selectedOption.value)}
                                        clearable={false}
                                    />
                                </div>
                            </div>
                            <div className="d-flex align-items-center">
                                <div className='label'>Inicio: </div>
                                <ParadigmaDatePicker
                                    datetime={false}
                                    monthpicker={false}
                                    value={this.state.startDate}
                                    onChange={(date) => this.onFechaChange(date, this.state.endDate)}
                                />
                                <div className='label'>Fin: </div>
                                <ParadigmaDatePicker
                                    datetime={false}
                                    monthpicker={false}
                                    value={this.state.endDate}
                                    onChange={(date) => this.onFechaChange(this.state.startDate, date)}
                                />
                            </div>
                        </div>
                        <div className='div-monto-total box'>
                            <p className='subtitulo'>Montos Totales</p>
                            <div className='div-fila-montos'>
                                <p className='item'>
                                    Pesos: 
                                    <div className='monto'>$ {dateFunctions.formatCurrency(montoTotalPesos)}</div>
                                </p>
                                <p className='item'>
                                    Dólar oficial: 
                                    <div className='monto'>U$S {dateFunctions.formatCurrency(montoTotalDolarOficial)}</div>
                                </p>
                                <p className='item'>
                                    Dólar MEP: 
                                    <div className='monto'>U$S {dateFunctions.formatCurrency(montoTotalDolarMep)}</div>
                                </p>
                            </div>
                        </div>
                    </div>
                )}
            />
        );
    }
}

export default Facturacion;



// WEBPACK FOOTER //
// ./src/views/Indicadores/Facturacion.js